/* Talas model tiles: lazy hover clip. No WebGL, no work until the tile is hovered, focused or (touch) scrolled into view. */
(() => {
  const tiles = document.querySelectorAll('[data-t3tile]');
  if (!tiles.length || window.__t3tiles) return;
  window.__t3tiles = true;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const conn = navigator.connection || {};
  const saveData = !!conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '');
  if (reduce || saveData) return; // poster only
  const canHover = matchMedia('(hover: hover)').matches;
  const webm = document.createElement('video').canPlayType('video/webm; codecs="vp9"');

  document.querySelectorAll('[data-t3tile]').forEach((tile) => {
    const v = tile.querySelector('video');
    let loaded = false, resetT = 0;
    const load = () => {
      if (loaded) return; loaded = true;
      const add = (src, type) => { if (!src) return; const s = document.createElement('source'); s.src = src; s.type = type; v.appendChild(s); };
      if (webm) add(tile.dataset.webm, 'video/webm; codecs="vp9"');
      add(tile.dataset.mp4, 'video/mp4');
      v.load();
    };
    const play = () => {
      clearTimeout(resetT); load();
      const p = v.play(); if (p && p.catch) p.catch(() => {});
      tile.classList.add('t3-playing');
    };
    const stop = () => {
      tile.classList.remove('t3-playing'); v.pause();
      resetT = setTimeout(() => { try { v.currentTime = 0; } catch (e) { /* not ready */ } }, 400);
    };
    v.addEventListener('ended', () => { /* hold the last frame while hovered */ });
    if (canHover) {
      tile.addEventListener('pointerenter', play); tile.addEventListener('pointerleave', stop);
      tile.addEventListener('focus', play); tile.addEventListener('blur', stop);
    } else if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((es) => es.forEach((e) => {
        if (e.isIntersecting && e.intersectionRatio > 0.6) { play(); io.unobserve(tile); }
      }), { threshold: [0.6] });
      io.observe(tile);
    }
  });
})();
